export interface TableInfoItemProps {
  item: string;
  value: string;
}

export const TableInfoItem = ({ item, value }: TableInfoItemProps) => {
  return (
    <div data-testid="table-info-item" className="pt-[29px] w-full">
      <p className="text-xs text-[#727272] font-normal">{item}</p>
      <p className="text-[15px]">{value}</p>
    </div>
  );
};
